import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    labelPersonal: '**Personal**',
    labelProfessional: '**Professional**',
    subTitle:
      'If your personal address is incomplete, you will be able to clarify it in the next step.',
    title: 'Choose a delivery address',
    warningBoxText:
      'In order to protect you against fraud, the delivery address of your card will be the billing address to indicate during your future online purchases.',
    warningBoxTitle: 'Regarding online purchases',
  },
  fr: {
    labelPersonal: '**Personnelle**',
    labelProfessional: '**Professionnelle**',
    subTitle:
      'Si votre adresse personnelle est incomplète, vous pourrez la préciser à l’étape suivante.',
    title: 'Choisissez une adresse de livraison',
    warningBoxText:
      'Afin de vous protéger contre la fraude, l’adresse de livraison de votre carte sera l’adresse de facturation à indiquer lors de vos futurs achats en ligne.',
    warningBoxTitle: 'Concernant les achats en ligne',
  },
} as const);

export default locales;
